import { symcodAccordeon } from "./accordeons.js";
import { sliderTemoignage } from "./slider_temoignages.js";
import { accueilSlider } from "./accueil_slider.js";
import { symcodsoumission } from "./formulaire-soumission.js";
import { symcod_sticky } from "./sticky-menu.js";
import { galerie_simple } from "./galerie-simple.js";

( function( $ , d , w ) {
	
	$(d).ready( function(){
		var windowWidth;
		//à,primaryH,primaryF;
		
		$("#main-navigation").on("click",".menu-item-has-children > a", function(){
			
			//if(windowWidth < 1024 ){
				//e.preventDefault();
			//}
			
			var parent = $(this).parent();
			if( windowWidth < 1100 ){
				
				if( parent.hasClass( "active" ) && !parent.hasClass("current-menu-item")){
					parent.removeClass("active");
					return;
				}
				
				$(".menu-item-has-children").removeClass("active");
				parent.addClass("active");	
			}
			
		});
		
		$("#mobile-menu").on("click","button", function(){
			$("body").toggleClass("menu-mobile-is-open");
			$("#searchform-mobile").slideUp(300);
			$(this).toggleClass("is-active");
		})
		
		$("#bouton-loupe").on("click", function(e){
			e.preventDefault();
			$("#searchform-mobile").slideToggle(300).addClass("active");
		});
		
	
		$(w).on("resize", function(){
			windowWidth = $(w).innerWidth();
			if( windowWidth < 768 ){
				$('body').toggleClass('symcod-mobile');
			}
			
	
		}).resize();
		
	
	
		$(w).scroll(function(){
		    if ($(w).scrollTop() >= 112) {
		        $('body').addClass('fixed-header');
		    }
		    else {
		        $('body').removeClass('fixed-header');
		    }
		});		
		
		$(".add-product-retour .gfield_checkbox").on("click","> li input",function(){
			var _adp = $(this);
			if( _adp.is(':checked') ){
				_adp.parent().addClass("actif");
				return true;
			}
			_adp.parent().removeClass("actif");
		});
		
		symcodAccordeon();
		sliderTemoignage();
		accueilSlider();
		symcodsoumission();
		symcod_sticky();
		galerie_simple();
				
		$(w).load( function(){
		
		});
	});

})(jQuery,document,window)